import React, { Component } from 'react'
import ListItem from './Portfolio/ListItem'

import '../../App.css';
import '../styles/Portfolio.css';

import ArrowLeft from '../../assets/Arrow Left.svg';
import Tape from '../../assets/Tape.svg';

export default class Portfolio extends Component {

	componentDidMount() {

		if (this.props.selectedArtistKey != null) {

			this.props.moveAction();

		} else {

			this.props.moveBackAction();

		}
	}

	convertDataToJSX(data, activeKey) {
		let columns = [];
		let numOfColumns = data.length / 5;
		let numOfRows = data.length / 2;

		if( numOfColumns < 1 ) {
			numOfColumns = data.length;
		}

		let currentArrayIndex = 0;
		for (let i = 0; i < numOfColumns; i++) {
			let cells = [];

			for (let k = 0; (k < numOfRows) && (currentArrayIndex < data.length); k++) {

				let artist = data[currentArrayIndex];
				const { key, name, picture } = artist;

				if (activeKey == null) {
					cells.push(
						<ListItem image={picture} name={name} inactive={false} clickFunc={this.props.selectArtistAction.bind(this, key)} />
					);
				} else {
					cells.push(
						<ListItem image={picture} name={name} inactive={key != activeKey} clickFunc={this.props.selectArtistAction.bind(this, key)} />
					);
				}

				currentArrayIndex++;
			}

			columns.push(cells);
		}

		let content = [];
		columns.forEach(function (cells) {
			content.push(<div className="column">
				{cells}
			</div>);
		})

		return content;
	}

	render() {

		let content = null;
		if (this.props.isLoading) {
			content = <div className="loading-text">Loading...</div>;
		} else {
			content = this.convertDataToJSX(this.props.artists, this.props.selectedArtistKey);
		}

		let containerMoved = '';

		if (this.props.selectedArtistKey != null) {
			containerMoved = 'moved';
		} else {
			containerMoved = '';
		}

		return (
			<div className={`moveable-horizontal-flex-container ${containerMoved}`} onClick={this.props.closeAction}>

				<div className="tape">
					<img src={Tape} className="asset" />
				</div>

				<div className="subpage-button-container">
					<div className="button-left" onClick={this.props.leftAction}>
						Portfolio
							<img src={ArrowLeft} className="leftArrow" />
					</div>
				</div>

				<div className="subpage-main-content-container">
					<div className={`artists-container ${containerMoved}`}>
						<div className="portfolio-outer-wrapper">
							<div className="portfolio-wrapper">
								{content}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}
